export function adjustTimestamp(ts: number, language: 'js' | 'php' = 'php'): number {
    switch (language) {
        case 'php':
            return Math.floor(ts / 1000);
        default:
            // return Math.floor(ts);
            return Math.floor(ts * 1000);
    }
}
